// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { Component } from 'react'
import { State } from '../../../../redux/reducers/initialState'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import { ICustomerViewModel } from '../../../../types/interfaces'

interface IProps extends WithTranslation {
  validCompany: string
  customers: ICustomerViewModel[]
}

interface IState {
  customer?: ICustomerViewModelVisibility
}

interface ICustomerViewModelVisibility extends ICustomerViewModel {
  visible: boolean
}

class ValidCompanies extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {}
  }
  componentDidMount(): void {
    this.updateCustomerState()
  }

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (this.props.validCompany !== prevProps.validCompany) {
      this.updateCustomerState()
    }
  }

  updateCustomerState(): void {
    let customer: ICustomerViewModelVisibility = null
    if (this.props.validCompany && this.props.customers.some((cu) => cu.id === this.props.validCompany)) {
      customer = {
        ...this.props.customers.find((cu) => cu.id === this.props.validCompany),
        visible: false,
      }
    }
    this.setState({ customer })
  }

  private toggleUnitsVisibility() {
    const customer = this.state.customer

    customer.visible = !customer.visible

    this.setState({ customer })
  }

  render() {
    return (
      <div className="valComp">
        <div className="detailTitle">
          <span>
            <i className="icon-units" />
            <span>Valid companies\units</span>
          </span>
        </div>
        <div className="ordersContent">
          {this.state.customer ? (
            <div>
              <div className="compName">
                <div>
                  <i className="icon-customers" />
                  {this.state.customer.name}
                </div>
                <div>
                  <i className="icon-id" /> <span>{this.state.customer.reference}</span>
                  <i
                    className={`${this.state.customer.visible ? 'icon-up' : 'icon-bottom'}`}
                    onClick={() => this.toggleUnitsVisibility(this.state.customer.id)}
                  />
                </div>
              </div>
              {this.state.customer.visible && (
                <ul className="unitsList">
                  {this.state.customer.units
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((un) => (
                      <li key={un.name}>{un.name || this.props.t('NO_COST_CENTER')}</li>
                    ))}
                </ul>
              )}
            </div>
          ) : (
            <div className="notFound">
              <i className="icon icon-warning"></i>
              <span>Selected owner is not found</span>
            </div>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps({ customers }: State) {
  return {
    customers: customers.customers,
  }
}

export default connect(mapStateToProps, {})(withTranslation('common')(ValidCompanies))
